import { AlertCircle, RotateCw } from "lucide-react";
import Button from "../ui/Button";

/**
 * A page that failed to draw, inside its page box on Preview (`PreviewFailed`):
 * alert, "Page 3 didn't draw" on every device (decided 2026-10-23: desktop
 * uses the phone wording, no "Try again, or replace the photo." line), then
 * Try again and Replace photo. After the second failed try only Replace photo is left (decided
 * 2026-10-23).
 */
const PageDrawFailed = ({ pageNumber, onRetry, onReplace, retrying = false, usedUp = false }) => (
  <div
    role="alert"
    className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 rounded-lg border-2 border-red-200 bg-white p-2.5 text-center lg:gap-2.5 lg:p-5"
  >
    <span aria-hidden="true" className="flex h-9 w-9 items-center justify-center rounded-full bg-red-50 text-red-700 lg:h-12 lg:w-12">
      <AlertCircle className="h-5 w-5 lg:h-6 lg:w-6" strokeWidth={2.2} />
    </span>
    <span className="text-sm font-bold leading-tight text-md-dark lg:text-base">Page {pageNumber} didn't draw</span>
    {usedUp ? <span className="text-[13px] leading-snug text-md-muted lg:text-sm">Please choose a different photo.</span> : null}
    {usedUp ? null : (
      <Button size="sm" className="mt-0.5 !min-h-[40px] lg:!min-h-[44px]" onClick={onRetry} busy={retrying} icon={<RotateCw className="h-4 w-4" aria-hidden="true" />}>
        Try again
      </Button>
    )}
    <Button variant="text" className="!text-sm lg:!text-[15px]" onClick={onReplace}>
      Replace photo
    </Button>
  </div>
);

export default PageDrawFailed;
